function normalize(value) {
  return value?.toString().toLowerCase() || "";
}

export function getOrderActionLabel(action, labels) {
  const normalizedAction = normalize(action);
  if (!normalizedAction) {
    return "";
  }
  if ("b" === normalizedAction || "buy" === normalizedAction) {
    return labels.buy;
  }
  if ("s" === normalizedAction || "sell" === normalizedAction) {
    return labels.sell;
  }

  return action?.toString().toUpperCase() || "";
}

export function getTransferTypeLabel(type, labels) {
  const normalizedType = normalize(type);
  if (!normalizedType) {
    return "";
  }

  return "b" === normalizedType ? labels.incoming : labels.outgoing;
}

export function getPurchaseTypeLabel(type, labels) {
  const normalizedType = normalize(type);
  if (!normalizedType) {
    return "";
  }

  return "market" === normalizedType ? labels.market : labels.limit;
}

export function getBackendOrderTypeLabel(type, labels) {
  const normalizedType = normalize(type).replace(/_/g, "-");
  if (!normalizedType) {
    return "";
  }

  switch (normalizedType) {
    case "1":
    case "market":
      return labels.market;
    case "2":
    case "limit":
      return labels.limit;
    case "5":
    case "stop-limit":
      return labels.stopLimit;
    case "10":
    case "stop-market":
      return labels.stopMarket;
    case "12":
    case "iceberg":
      return labels.iceberg;
    default:
      return type?.toString().toUpperCase() || "";
  }
}

export function getOrderStatusLabel(order, labels) {
  if (!order) {
    return "n/a";
  }

  switch (parseInt(order.status)) {
    case 1:
    case 2:
    case 12:
    case 99:
      return labels.processing;
    case 3:
      return labels.placed;
    case 4:
    case 5:
      return labels.cancelled;
    case 6:
    case 7:
      return labels.filled;
    default:
      return "n/a";
  }
}
